/** Import config */
import { EventClass, EventType } from "../config/Events";
import { MENU_POPUPS } from "../config/Game";

import { modalWindowOptionsInit, ModalWindowOptions } from '../../_core/components/ui/popup/Popup.config';

/** Import core classes */
import { __EventDispatcher } from "../../_core/core";
/** Import Store Components */ 
 
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import Popup, { PopupInterface } from "../../_core/components/ui/popup/Popup";
import BetPopup from "../components/popups/bet/Popup.Bet";
import ResultsPopup from "../components/popups/results/Popup.Results";
 
const MenusController = (_props: any) => {

  const [currentPopup, setCurrentPopup ] = useState<MENU_POPUPS|null>(); 
  const [payload, setPayload] = useState<any>();

  const cleanPopup = () => {
    setCurrentPopup(null);
  }

  const onEventDispatched = (_eventClass: EventClass, _eventType: string, _eventPayload?: any) => {
    if (_eventClass !== EventClass.GUI) return false;
    modalWindowOptionsInit(); 
    setPayload(_eventPayload);
    switch(_eventType) {
      case EventType.GUI.SHOW_POPUP:
        cleanPopup();
        setCurrentPopup(_eventPayload.type); 
        break;
      case EventType.GUI.CLEAR_POPUP: 
        cleanPopup();
        break;
    }
  }

  useEffect(() => {
    __EventDispatcher.addListener(EventClass.GUI, onEventDispatched, {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if(currentPopup && ModalWindowOptions.has(currentPopup)) {
    let _popupOptions = {
      ...ModalWindowOptions.get(currentPopup),
      ...payload
    }
 
    switch(currentPopup) {
      case MENU_POPUPS.POPUP_BET:
        return (<BetPopup />); 
      case MENU_POPUPS.POPUP_RESULTS: 
        return (<ResultsPopup />);
      default: 
        return (<Popup {..._popupOptions as PopupInterface }/>);
    }
  }
  
  return null;
}

const mapStateToProps = (state: any) => {
  return {
    GUI_DATA: state.game.GUI_DATA,
    GAMEPLAY_SETTINGS: state.game.GAMEPLAY_SETTINGS,
    SESSION_DATA: state.game.SESSION_DATA,
    STATUS_DATA: state.game.STATUS_DATA,
  };
}

export default connect(mapStateToProps, {})(MenusController);